export default "__VITE_ASSET__Bj$AFKbo__"